import { defineComponent } from "vue";
const reducedMotionMixin = defineComponent({
  data() {
    return {
      prefersReducedMotion: false
    };
  },
  mounted() {
    this.checkReducedMotion();
  },
  methods: {
    checkReducedMotion() {
      this.prefersReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`).matches;
    }
  }
});
export {
  reducedMotionMixin as default
};
